import { isEmpty, camelCase } from 'lodash';

const selectGameCard = (phrases, game) => ((!isEmpty(phrases) && !isEmpty(game)) ? ({
  name: phrases[camelCase(game.name)],
  description: phrases.descriptions[camelCase(game.name)],
  path: game.path,
  remaining: game.remaining,
  completed: game.remaining === 0,
  phrases: {
    completed: phrases.gamesCompleted,
    games: (game.remaining === 1) ? phrases.test : phrases.tests,
  },
}) : null);

export default selectGameCard;
